import {Link, useNavigate} from "react-router-dom";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {useAuth} from "../context/auth-context";
import Swal from "sweetalert2";
import {MuiFab} from "./MuiFab";
import {getUrl, PWAUrls} from "../config/urls";
import {useAddToCart, useRemoveFromCart} from "../hooks/useCart";
import {toast} from "react-toastify";

/**
 * Composant de FabRoute
 */
const FabRoute = ({t, i18n, unlock, type, route, product}) => {
    const auth = useAuth();

    const hasValidatedGuidebook = auth.hasValidatedGuidebook(route);
    const hasParentGuidebookInCart = auth.hasParentGuidebookInCart(route);
    const isInCart = hasParentGuidebookInCart || auth.isInCart(product);
    const history = useNavigate();
    const { data: dataRemoveFromCart , mutateAsync: mutateRemoveFromCart, status: statusRemoveFromCart, error: errorRemoveFromCart } = useRemoveFromCart(i18n.language, t('App.screens.CartScreen.removedFromCart'));
    const { data: dataAddToCart , mutateAsync: mutateAddToCart, status: statusAddToCart, error: errorAddToCart }   = useAddToCart(i18n.language, t('App.screens.CartScreen.addedToCart'));
    const addToCart = (product) => {
        try {
            mutateAddToCart(product);
        } catch (e) {
            toast.error(t('common.error.save'));
        }
    }
    const removeFromCart = (product) => {
        try {
            mutateRemoveFromCart(product);
        } catch (e) {
            toast.error(t('common.error.save'));
        }
    }

    if (!unlock && hasValidatedGuidebook) {
        return <>
            <MuiFab component={Link}
                 to={auth.getValidationLink(route, i18n.language)}
                 variant="extended"
                 color="secondary"
                 size="medium"
                 style={{position: "fixed", bottom: "72px", right: "16px",}}>
                <FontAwesomeIcon icon={["fas", "unlock"]}/>
                &nbsp; {t('SecteurComponent.unlock.' + type)}
            </MuiFab>
            <div style={{height: '40px'}}>&nbsp;</div>
        </>;
    }

    if (unlock || product?.price === null || hasValidatedGuidebook || typeof product === "undefined") {
        return null;
    }

    if (!isInCart && product?.priceLabel) {
        return (<>
            <MuiFab variant="extended" color="tertiary" size="medium"
                 style={{position: "fixed", bottom: "72px", right: "16px",}}
                    disabled={statusAddToCart === 'pending'}
                 onClick={() => {
                     if (auth.isAuthenticated) {
                         addToCart(product);
                     } else {
                         Swal.fire({
                             titleText: t('AlertComponent.login.addToCart.title'),
                             icon: 'warning',
                             text: t('AlertComponent.login.addToCart.message'),
                             showCancelButton: true,
                             confirmButtonText: t('TopoValidationScreen.alert.guestCta'),
                             cancelButtonText: t('SecteurComponent.bookmark.update_bookmark.cancelButton'),
                             reverseButtons: true
                         }).then((result) => {
                             if (result.value) {
                                 history(getUrl(PWAUrls.USER_PROFILE, {lng: i18n.language}));
                                 //Redirection pour le moment
                                 //setRedirectTo('/activation');
                                 // if (isCurrentPageBookmarked) {
                                 //     unsaveRoute();
                                 // } else {
                                 //     saveRoute();
                                 // }

                             } else if (
                                 /* Read more about handling dismissals below */
                                 result.dismiss === Swal.DismissReason.cancel
                             ) {
                             }
                         });
                     }
                 }}
            >
                <FontAwesomeIcon icon={["fas", "cart-plus"]}/>
                &nbsp; {product.priceLabel} &nbsp; {t('SecteurComponent.addToCart.' + type)}
            </MuiFab>
            <div style={{height: '40px'}}>&nbsp;</div>
        </>)
    }

    if (isInCart) {
        return (<>
            <MuiFab variant="extended" color="primary" size="medium"
                 style={{position: "fixed", bottom: "72px", right: "16px",}}
                 onClick={() => removeFromCart(product)}
            >
                <FontAwesomeIcon icon={["fas", "check"]}/>
                &nbsp; {product.priceLabel} &nbsp; {t('SecteurComponent.removeFromCart')}
            </MuiFab>
            <div style={{height: '40px'}}>&nbsp;</div>
        </>);
    }

    return null;
}

export default compose(
    withTranslation()
)(FabRoute);
